import { PropsWithChildren } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { Image } from '@app/components/core/image/Image'
import { useLocation } from 'wouter'
import { Style } from 'inlines'

export interface EmptyProps extends PropsWithChildren {
  title: string
  imageSrc?: string
  ctaLabel?: string
  ctaLink?: string
  style?: Style
}

export const Empty = ({
  title,
  imageSrc,
  ctaLabel,
  ctaLink,
  children,
  style,
}: EmptyProps) => {
  const [, setLocation] = useLocation()

  return (
    <Column alignItems="center" gap="1rem" style={style}>
      {imageSrc && (
        <Image
          src={imageSrc}
          alt={title}
          resizeWidth={320}
          style={{ maxWidth: '320px' }}
        />
      )}

      <Title.H4>{title}</Title.H4>

      {children}

      {ctaLabel && ctaLink && (
        <Button
          variant="primary"
          size="medium"
          label={ctaLabel}
          onClick={() => setLocation(ctaLink)}
        />
      )}
    </Column>
  )
}
